module.exports = __webpack_public_path__ + "static/media/palms-events-top-right.fe9ba9ed.png";